import React, { useState } from "react";

import { createStage, checkCollision } from "../gameHelpers.js";

// Styled Components
import { StyledTetrisWrapper, StyledTetris } from "./styles/StyledTetris.js";

// Components
import Stage from "./Stage.js";
import Display from "./Display.js";
import StartButton from "./StartButton.js";

// Custom Hooks
import { usePlayer } from '../hooks/usePlayer.js';
import { useStage } from '../hooks/useStage.js'
import { useInterval } from '../hooks/useInterval.js'
import { useGameStatus } from "../hooks/useGameStatus.js";

const Tetris = () => {
  const [dropTime, setDropTime] = useState(null);
  const [gameOver, setGameOver] = useState(false);

  const [player, updatePlayerPos, resetPlayer, playerRotate] = usePlayer();
  const [stage, setStage, rowsCleared] = useStage(player, resetPlayer);
  const [score, setScore, rows, setRows, level, setLevel] = useGameStatus(rowsCleared);
  const theme = document.getElementById("theme")

  const movePlayer = dir => {
    if(!checkCollision(player, stage, {x: dir, y: 0})){
      updatePlayerPos({x: dir, y: 0});
    }
  }

  const startGame = () => {
    setStage(createStage());
    setDropTime(1000);
    resetPlayer();
    setGameOver(false);
    setScore(0)
    setRows(0)
    setLevel(0)
    theme.play()
  }

  const drop = () => {
    if(rows > (level + 1) * 10){
      setLevel(prev => prev + 1)
      setDropTime(1000 / (level + 1) + 200)
    }
    if(!checkCollision(player, stage, {x: 0, y: 1})){
      updatePlayerPos({x: 0, y: 1, collided: false})
    }else {
      if(player.pos.y < 1){
        console.log("Game Over!")
        setGameOver(true)
        setDropTime(null)
        theme.pause()
        theme.currentTime = 0;
      }
      updatePlayerPos({x: 0, y: 0, collided: true})
    }
  }

  const keyUp = ({keyCode}) => {
    if(!gameOver){
      if(keyCode === 40){
        setDropTime(1000 / (level + 1) + 200);
      }
    }
  }

  const dropPlayer = () => {
    setDropTime(null);
    drop();
  }

  const move = ({keyCode}) => {
    if(!gameOver){
      if(keyCode === 37){
        movePlayer(-1);
      }else if(keyCode === 39){
        movePlayer(1)
      }else if(keyCode === 40){
        dropPlayer();
      }else if(keyCode === 38){
        playerRotate(stage, 1)
      }
    }
  }

  useInterval(() => {
    drop();
  }, dropTime)

  return(
    <StyledTetrisWrapper role="button" tabIndex={0} onKeyDown={e => move(e)} onKeyUp={keyUp}>
      <StyledTetris>
        <Stage stage={stage}/>
        <aside>
          {gameOver ? (
            <>
            <Display gameOver={gameOver} text="Game Over" />
            <Display text={`Score: ${score}`}/>
            <Display text={`Rows: ${rows}`}/>
            <Display text={`Level: ${level}`}/>
            </>
          ) : (
            <div>
              <Display text={`Score: ${score}`}/>
              <Display text={`Rows: ${rows}`}/>
              <Display text={`Level: ${level}`}/>
            </div>
          )}
          <StartButton callback={startGame}/>
        </aside>
      </StyledTetris>
    <audio id="theme" loop>
      <source src="Theme-Song.wav" type="audio/wav"></source>
    </audio>
    </StyledTetrisWrapper>
  )
}

export default Tetris;